import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const LockedFeatureModal = ({ open, title, onClose }) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,0,0,0.5)',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <Paper
        sx={{ p: 4, maxWidth: 400, width: '90%', borderRadius: 3 }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
          {title} (Función Bloqueada)
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          El módulo de <strong>{title}</strong> no está incluido en tu plan actual.
          Para agregar esta funcionalidad a tu suscripción, dirigite a <strong>Mi Suscripción</strong>.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cerrar
          </Button>
          <Button
            onClick={() => {
              onClose();
              navigate('/saas/dashboard');
            }}
            variant="contained"
            color="primary"
          >
            Ver mi Suscripción
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LockedFeatureModal;
